import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useApproval } from '../context/ApprovalContext';
import { X, ChevronRight, Info, Plus, Trash2, Paperclip } from 'lucide-react';

// 인사명령 테이블
function PersonnelTable({ value, onChange }) {
  const rows = value || Array(5).fill(null).map(() => ({ org: '--', name: '', grade: '--', startDate: '', endDate: '', task: '--', type: '--', remark: '' }));
  const update = (i, key, val) => { const n = [...rows]; n[i] = { ...n[i], [key]: val }; onChange(n); };
  const orgOpts = ['--', '노아에이티에스(주)', '고객사', '기타'];
  const gradeOpts = ['--', '사원', '대리', '과장', '차장', '부장', '이사', '대표'];
  const taskOpts = ['--', '개발', '분석', '설계', 'PM', 'QA', '기타'];
  const typeOpts = ['--', '상주', '비상주', '재택'];
  return (
    <div style={{ overflowX: 'auto', border: '1px solid #e5e7eb', borderRadius: 8 }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
        <thead>
          <tr style={{ background: '#f9fafb' }}>
            {['구분', '소속', '대상자', '직급', '투입일', '종료일', '담당업무', '투입형태', '비고'].map(h => (
              <th key={h} style={{ padding: '8px 6px', borderBottom: '1px solid #e5e7eb', fontWeight: 600, color: '#374151', whiteSpace: 'nowrap' }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i} style={{ borderBottom: '1px solid #f3f4f6' }}>
              <td style={{ padding: '4px 6px', textAlign: 'center', color: '#9ca3af' }}>{i + 1}</td>
              <td style={{ padding: '4px 3px' }}><select style={{ fontSize: 11, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '3px' }} value={row.org} onChange={e => update(i, 'org', e.target.value)}>{orgOpts.map(o => <option key={o}>{o}</option>)}</select></td>
              <td style={{ padding: '4px 3px' }}><input style={{ fontSize: 11, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '3px' }} value={row.name} onChange={e => update(i, 'name', e.target.value)} /></td>
              <td style={{ padding: '4px 3px' }}><select style={{ fontSize: 11, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '3px' }} value={row.grade} onChange={e => update(i, 'grade', e.target.value)}>{gradeOpts.map(o => <option key={o}>{o}</option>)}</select></td>
              <td style={{ padding: '4px 3px' }}><input type="date" style={{ fontSize: 10, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '3px' }} value={row.startDate} onChange={e => update(i, 'startDate', e.target.value)} /></td>
              <td style={{ padding: '4px 3px' }}><input type="date" style={{ fontSize: 10, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '3px' }} value={row.endDate} onChange={e => update(i, 'endDate', e.target.value)} /></td>
              <td style={{ padding: '4px 3px' }}><select style={{ fontSize: 11, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '3px' }} value={row.task} onChange={e => update(i, 'task', e.target.value)}>{taskOpts.map(o => <option key={o}>{o}</option>)}</select></td>
              <td style={{ padding: '4px 3px' }}><select style={{ fontSize: 11, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '3px' }} value={row.type} onChange={e => update(i, 'type', e.target.value)}>{typeOpts.map(o => <option key={o}>{o}</option>)}</select></td>
              <td style={{ padding: '4px 3px' }}><input style={{ fontSize: 11, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '3px' }} value={row.remark} onChange={e => update(i, 'remark', e.target.value)} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// 지출결의서 테이블
function ExpenseTable({ value, onChange }) {
  const rows = value || Array(4).fill(null).map(() => ({ date: '', category: '--', vendor: '', user: '', amount: '' }));
  const update = (i, key, val) => { const n = [...rows]; n[i] = { ...n[i], [key]: val }; onChange(n); };
  const cats = ['--', '교통비', '식대', '숙박비', '업무용품', '통신비', '교육비', '접대비', '기타'];
  return (
    <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
        <thead>
          <tr style={{ background: '#f9fafb' }}>
            {['지출 일자', '지출 내역', '거래처명', '사용자', '금액'].map(h => (
              <th key={h} style={{ padding: '10px 8px', borderBottom: '1px solid #e5e7eb', fontWeight: 600, color: '#374151' }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i} style={{ borderBottom: '1px solid #f3f4f6' }}>
              <td style={{ padding: '6px 4px' }}><input type="date" style={{ fontSize: 12, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '4px' }} value={row.date} onChange={e => update(i, 'date', e.target.value)} /></td>
              <td style={{ padding: '6px 4px' }}><select style={{ fontSize: 12, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '4px' }} value={row.category} onChange={e => update(i, 'category', e.target.value)}>{cats.map(c => <option key={c}>{c}</option>)}</select></td>
              <td style={{ padding: '6px 4px' }}><input style={{ fontSize: 12, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '4px' }} value={row.vendor} onChange={e => update(i, 'vendor', e.target.value)} /></td>
              <td style={{ padding: '6px 4px' }}><input style={{ fontSize: 12, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '4px' }} value={row.user} onChange={e => update(i, 'user', e.target.value)} /></td>
              <td style={{ padding: '6px 4px' }}><input style={{ fontSize: 12, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '4px', textAlign: 'right' }} placeholder="원" value={row.amount} onChange={e => update(i, 'amount', e.target.value)} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// 출장자 테이블
function TravelerTable({ value, onChange }) {
  const rows = value || Array(5).fill(null).map(() => ({ name: '', grade: '--', startDate: '', endDate: '', budget: '' }));
  const update = (i, key, val) => { const n = [...rows]; n[i] = { ...n[i], [key]: val }; onChange(n); };
  const grades = ['--', '사원', '대리', '과장', '차장', '부장', '이사', '대표'];
  return (
    <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
        <thead>
          <tr style={{ background: '#f9fafb' }}>
            {['성명', '직급', '출장 기간 (시작)', '출장 기간 (종료)', '출장 예산 (원)'].map(h => (
              <th key={h} style={{ padding: '10px 8px', borderBottom: '1px solid #e5e7eb', fontWeight: 600, color: '#374151' }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i} style={{ borderBottom: '1px solid #f3f4f6' }}>
              <td style={{ padding: '6px 4px' }}><input style={{ fontSize: 12, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '4px' }} value={row.name} onChange={e => update(i, 'name', e.target.value)} /></td>
              <td style={{ padding: '6px 4px' }}><select style={{ fontSize: 12, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '4px' }} value={row.grade} onChange={e => update(i, 'grade', e.target.value)}>{grades.map(g => <option key={g}>{g}</option>)}</select></td>
              <td style={{ padding: '6px 4px' }}><input type="date" style={{ fontSize: 12, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '4px' }} value={row.startDate} onChange={e => update(i, 'startDate', e.target.value)} /></td>
              <td style={{ padding: '6px 4px' }}><input type="date" style={{ fontSize: 12, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '4px' }} value={row.endDate} onChange={e => update(i, 'endDate', e.target.value)} /></td>
              <td style={{ padding: '6px 4px' }}><input style={{ fontSize: 12, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '4px', textAlign: 'right' }} placeholder="원" value={row.budget} onChange={e => update(i, 'budget', e.target.value)} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// 물품 신청 테이블
function SupplyTable({ value, onChange }) {
  const cats = ['--', '데스크탑', '모니터', '노트북', '프로젝터', '마우스', '키보드', '헤드셋', '기타'];
  const rows = value || Array(4).fill(null).map((_, i) => ({ category: '--', user: '', productName: '', requestReason: '', quantity: '', startDate: '', endDate: '', unitPrice: '', total: '', remark: '' }));
  const update = (i, key, val) => { const n = [...rows]; n[i] = { ...n[i], [key]: val }; onChange(n); };
  return (
    <div>
      {rows.map((row, i) => (
        <div key={i} style={{ border: '1px solid #e5e7eb', borderRadius: 8, padding: 14, marginBottom: 12, background: '#fafafa' }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: '#4f46e5', marginBottom: 10 }}>품목 {i + 1}</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            <div><label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 3 }}>품목 종류</label><select style={{ fontSize: 12, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '5px' }} value={row.category} onChange={e => update(i, 'category', e.target.value)}>{cats.map(c => <option key={c}>{c}</option>)}</select></div>
            <div><label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 3 }}>사용자</label><input style={{ fontSize: 12, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '5px' }} value={row.user} onChange={e => update(i, 'user', e.target.value)} /></div>
            <div><label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 3 }}>상품명</label><input style={{ fontSize: 12, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '5px' }} placeholder="필수값 입니다." value={row.productName} onChange={e => update(i, 'productName', e.target.value)} /></div>
            <div><label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 3 }}>신청 사유</label><input style={{ fontSize: 12, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '5px' }} placeholder="필수값 입니다." value={row.requestReason} onChange={e => update(i, 'requestReason', e.target.value)} /></div>
            <div><label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 3 }}>수량</label><input style={{ fontSize: 12, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '5px' }} placeholder="필수값 입니다." value={row.quantity} onChange={e => update(i, 'quantity', e.target.value)} /></div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
              <div><label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 3 }}>사용기간 시작</label><input type="date" style={{ fontSize: 11, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '5px' }} value={row.startDate} onChange={e => update(i, 'startDate', e.target.value)} /></div>
              <div><label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 3 }}>사용기간 종료</label><input type="date" style={{ fontSize: 11, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '5px' }} value={row.endDate} onChange={e => update(i, 'endDate', e.target.value)} /></div>
            </div>
            <div><label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 3 }}>단가</label><input style={{ fontSize: 12, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '5px' }} value={row.unitPrice} onChange={e => update(i, 'unitPrice', e.target.value)} /></div>
            <div><label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 3 }}>총액</label><input style={{ fontSize: 12, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '5px' }} value={row.total} onChange={e => update(i, 'total', e.target.value)} /></div>
            <div style={{ gridColumn: '1 / -1' }}><label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 3 }}>비고</label><input style={{ fontSize: 12, width: '100%', border: '1px solid #e5e7eb', borderRadius: 4, padding: '5px' }} value={row.remark} onChange={e => update(i, 'remark', e.target.value)} /></div>
          </div>
        </div>
      ))}
    </div>
  );
}

// 파일 첨부 컴포넌트
function FileAttachment({ files, onChange }) {
  const fileRef = useRef();
  const handleAdd = (e) => {
    const newFiles = Array.from(e.target.files).map(f => ({ name: f.name, size: f.size, file: f }));
    onChange([...(files || []), ...newFiles]);
    fileRef.current.value = '';
  };
  const handleRemove = (i) => onChange((files || []).filter((_, idx) => idx !== i));
  return (
    <div style={{ border: '2px dashed #e5e7eb', borderRadius: 8, padding: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: (files && files.length > 0) ? 12 : 0 }}>
        <Paperclip size={16} color="#9ca3af" />
        <span style={{ fontSize: 13, color: '#6b7280' }}>파일 첨부</span>
        <button type="button" className="btn btn-secondary btn-sm" style={{ marginLeft: 'auto' }} onClick={() => fileRef.current.click()}>
          <Plus size={13} /> 파일 추가
        </button>
        <input ref={fileRef} type="file" multiple style={{ display: 'none' }} onChange={handleAdd} />
      </div>
      {files && files.length > 0 && (
        <div>
          {files.map((f, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 0', borderTop: '1px solid #f3f4f6' }}>
              <Paperclip size={13} color="#4f46e5" />
              <span style={{ fontSize: 13, flex: 1, color: '#374151' }}>{f.name}</span>
              <span style={{ fontSize: 11, color: '#9ca3af' }}>{(f.size / 1024).toFixed(1)} KB</span>
              <button type="button" onClick={() => handleRemove(i)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444', padding: 2 }}><Trash2 size={13} /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function NewApproval() {
  const { user } = useAuth();
  const { addApproval, APPROVAL_TYPES, APPROVAL_CATEGORIES } = useApproval();
  const navigate = useNavigate();

  const [step, setStep] = useState(1);
  const [selectedType, setSelectedType] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [docTitle, setDocTitle] = useState('');
  const [formData, setFormData] = useState({});
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [approvers, setApprovers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [activeCategory, setActiveCategory] = useState('general');

  useEffect(() => {
    const fetchUsers = async () => {
      setLoadingUsers(true);
      try {
        const res = await fetch('/api/users');
        const data = await res.json();
        setAllUsers(data.filter(u => u.id !== user.id));
      } catch (e) { console.error('직원 목록 조회 실패:', e); }
      finally { setLoadingUsers(false); }
    };
    fetchUsers();
  }, [user.id]);

  const handleSelectType = (type) => {
    setSelectedType(type); setFormData({}); setAttachedFiles([]);
    setDocTitle(type.label); setShowForm(true);
  };
  const handleFormClose = () => { setShowForm(false); setStep(1); };
  const handleFormConfirm = () => { setShowForm(false); setStep(2); };

  const toggleApprover = (ap) => {
    setApprovers(prev =>
      prev.find(a => a.id === ap.id)
        ? prev.filter(a => a.id !== ap.id)
        : [...prev, { id: ap.id, name: ap.name, position: ap.position, dept: ap.dept }]
    );
  };

  const handleSubmit = async () => {
    if (!docTitle) { alert('결재 제목을 입력해주세요.'); return; }
    if (approvers.length === 0) { alert('결재자를 1명 이상 선택해주세요.'); return; }
    const newAp = await addApproval({
      type: selectedType.id,
      title: docTitle,
      author: { id: user.id, name: user.name, dept: user.dept, position: user.position },
      approvers: approvers.map(a => ({ ...a, status: 'pending', comment: '', date: '' })),
      formData,
      attachedFiles: attachedFiles.map(f => ({ name: f.name, size: f.size })),
    });
    if (newAp) navigate(`/detail/${newAp.id}`);
  };

  const isSelected = (id) => approvers.some(a => a.id === id);
  const getOrder = (id) => approvers.findIndex(a => a.id === id) + 1;
  const catTypes = APPROVAL_TYPES.filter(t => t.category === activeCategory);

  const setField = (key, val) => setFormData(prev => ({ ...prev, [key]: val }));

  // gridGroup 기반 2열 렌더링
  const renderFields = (type) => {
    const rendered = new Set();
    const result = [];
    const fields = type.fields;

    fields.forEach((field, idx) => {
      if (rendered.has(field.key)) return;

      if (field.gridGroup) {
        const group = fields.filter(f => f.gridGroup === field.gridGroup);
        if (group[0].key === field.key) {
          rendered.add(...group.map(f => f.key));
          result.push(
            <div key={field.key} style={{ display: 'grid', gridTemplateColumns: `repeat(${group.length}, 1fr)`, gap: 12 }}>
              {group.map(f => (
                <div key={f.key} className="form-group">
                  <label className="form-label">{f.label}{f.required && <span style={{ color: '#ef4444' }}> *</span>}</label>
                  {renderSingleField(f)}
                </div>
              ))}
            </div>
          );
        }
        return;
      }

      rendered.add(field.key);
      result.push(
        <div key={field.key} className="form-group">
          <label className="form-label">{field.label}{field.required && <span style={{ color: '#ef4444' }}> *</span>}</label>
          {renderSingleField(field)}
        </div>
      );
    });
    return result;
  };

  const renderSingleField = (field) => {
    if (field.type === 'info') return (
      <div style={{ padding: '10px 14px', background: '#fff8f0', border: '1px solid #fed7aa', borderRadius: 8, fontSize: 13, color: '#92400e', display: 'flex', gap: 8 }}>
        <Info size={14} style={{ marginTop: 1, flexShrink: 0 }} /><span>{field.value}</span>
      </div>
    );
    if (field.type === 'checkbox') return (
      <div style={{ padding: '12px 16px', background: '#f9fafb', borderRadius: 8 }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}>
          <input type="checkbox" checked={!!formData[field.key]} onChange={e => setField(field.key, e.target.checked)}
            style={{ width: 16, height: 16, cursor: 'pointer' }} />
          <span style={{ fontSize: 13, color: '#374151' }}>{field.checkLabel}</span>
        </label>
      </div>
    );
    if (field.type === 'personnel_table') return <PersonnelTable value={formData[field.key]} onChange={v => setField(field.key, v)} />;
    if (field.type === 'expense_table') return <ExpenseTable value={formData[field.key]} onChange={v => setField(field.key, v)} />;
    if (field.type === 'traveler_table') return <TravelerTable value={formData[field.key]} onChange={v => setField(field.key, v)} />;
    if (field.type === 'supply_table') return <SupplyTable value={formData[field.key]} onChange={v => setField(field.key, v)} />;
    if (field.type === 'richtext') return (
      <textarea className="form-textarea" placeholder={field.placeholder} value={formData[field.key] || ''}
        onChange={e => setField(field.key, e.target.value)} style={{ minHeight: 200, fontFamily: 'inherit' }} />
    );
    if (field.type === 'textarea') return (
      <textarea className="form-textarea" placeholder={field.placeholder} value={formData[field.key] || ''}
        onChange={e => setField(field.key, e.target.value)} style={{ minHeight: 80 }} />
    );
    if (field.type === 'select') return (
      <select className="form-select" value={formData[field.key] || ''} onChange={e => setField(field.key, e.target.value)}>
        <option value="">선택하세요</option>
        {field.options.map(o => <option key={o} value={o}>{o}</option>)}
      </select>
    );
    return (
      <input className="form-input" type={field.type === 'date' ? 'date' : 'text'}
        placeholder={field.placeholder || ''} value={formData[field.key] || ''}
        onChange={e => setField(field.key, e.target.value)} />
    );
  };

  return (
    <div className="page container">
      {/* 양식 팝업 */}
      {showForm && selectedType && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 }}>
          <div style={{ background: '#fff', borderRadius: 16, width: '100%', maxWidth: 720, maxHeight: '94vh', display: 'flex', flexDirection: 'column', boxShadow: '0 24px 80px rgba(0,0,0,0.3)' }}>
            {/* 헤더 */}
            <div style={{ padding: '16px 28px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#fff', borderRadius: '16px 16px 0 0' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <span style={{ fontSize: 24 }}>{selectedType.icon}</span>
                <div>
                  <h2 style={{ fontSize: 18, fontWeight: 700, margin: 0 }}>{selectedType.label}</h2>
                  <p style={{ fontSize: 12, color: '#9ca3af', margin: 0 }}>아래 양식을 작성하세요</p>
                </div>
              </div>
              <button onClick={handleFormClose} style={{ background: 'none', border: 'none', cursor: 'pointer' }}><X size={20} color="#9ca3af" /></button>
            </div>

            {/* 본문 */}
            <div style={{ overflowY: 'auto', flex: 1, padding: '20px 28px' }}>
              {/* 기안자 정보 */}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', marginBottom: 20, border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
                {[['기안자', user.name], ['소속', user.dept || '-'], ['기안일', new Date().toLocaleDateString('ko-KR')], ['문서번호', '(자동부여)']].map(([label, value]) => (
                  <div key={label} style={{ padding: '10px 14px', borderRight: '1px solid #e5e7eb', background: '#f9fafb' }}>
                    <div style={{ fontSize: 11, color: '#6b7280', fontWeight: 600, marginBottom: 3, textAlign: 'center' }}>{label}</div>
                    <div style={{ fontSize: 13, color: '#111827', textAlign: 'center' }}>{value}</div>
                  </div>
                ))}
              </div>

              {/* 가이드 */}
              {selectedType.guide && (
                <div style={{ padding: '12px 16px', background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: 8, marginBottom: 20 }}>
                  <div style={{ fontSize: 12, color: '#0369a1', fontWeight: 600, marginBottom: 6, display: 'flex', alignItems: 'center', gap: 4 }}>
                    <Info size={13} /> GUIDE
                  </div>
                  <pre style={{ fontSize: 12, color: '#0c4a6e', margin: 0, whiteSpace: 'pre-wrap', lineHeight: 1.7, fontFamily: 'inherit' }}>{selectedType.guide}</pre>
                </div>
              )}

              {/* 결재 제목 */}
              <div className="form-group">
                <label className="form-label">결재 제목 <span style={{ color: '#ef4444' }}>*</span></label>
                <input className="form-input" value={docTitle} onChange={e => setDocTitle(e.target.value)} placeholder="결재 제목을 입력하세요" />
              </div>

              <div style={{ borderTop: '1px solid #f3f4f6', paddingTop: 16 }}>
                {renderFields(selectedType)}
              </div>

              {/* 파일 첨부 */}
              <div className="form-group" style={{ marginTop: 16 }}>
                <label className="form-label">파일 첨부</label>
                <FileAttachment files={attachedFiles} onChange={setAttachedFiles} />
              </div>
            </div>

            {/* 푸터 */}
            <div style={{ padding: '14px 28px', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'flex-end', gap: 10, background: '#fff', borderRadius: '0 0 16px 16px' }}>
              <button className="btn btn-secondary" onClick={handleFormClose}>취소</button>
              <button className="btn btn-primary" onClick={handleFormConfirm}>
                다음 단계 (결재선 설정) <ChevronRight size={15} />
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Step 1 */}
      {step === 1 && !showForm && (
        <>
          <div className="page-header">
            <h1 className="page-title">결재 작성</h1>
            <p className="page-subtitle">결재 유형을 선택하세요</p>
          </div>
          <div style={{ display: 'flex', gap: 4, marginBottom: 24, background: '#f3f4f6', padding: 4, borderRadius: 10, width: 'fit-content' }}>
            {APPROVAL_CATEGORIES.map(cat => (
              <button key={cat.id} onClick={() => setActiveCategory(cat.id)}
                style={{ padding: '8px 20px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 14,
                  fontWeight: activeCategory === cat.id ? 600 : 400,
                  background: activeCategory === cat.id ? '#fff' : 'transparent',
                  color: activeCategory === cat.id ? '#4f46e5' : '#6b7280',
                  boxShadow: activeCategory === cat.id ? '0 1px 4px rgba(0,0,0,0.1)' : 'none' }}>
                {cat.icon} {cat.label}
              </button>
            ))}
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 14 }}>
            {catTypes.map(t => (
              <div key={t.id} onClick={() => handleSelectType(t)}
                style={{ background: '#fff', borderRadius: 12, padding: '22px 16px', textAlign: 'center', cursor: 'pointer',
                  border: '2px solid transparent', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', transition: 'all .2s' }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = '#4f46e5'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = 'transparent'; e.currentTarget.style.transform = 'translateY(0)'; }}>
                <div style={{ fontSize: 38, marginBottom: 10 }}>{t.icon}</div>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#111827', lineHeight: 1.4 }}>{t.label}</div>
              </div>
            ))}
          </div>
        </>
      )}

      {/* Step 2 */}
      {step === 2 && selectedType && (
        <>
          <div className="page-header" style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
            <button className="btn btn-secondary btn-sm" onClick={() => setStep(1)}>← 뒤로</button>
            <div style={{ flex: 1 }}>
              <h1 className="page-title">{selectedType.icon} {docTitle}</h1>
              <p className="page-subtitle">{selectedType.label} · 결재자를 순서대로 선택하세요</p>
            </div>
            <button className="btn btn-secondary btn-sm" onClick={() => setShowForm(true)}>📝 양식 수정</button>
          </div>

          {/* 작성 내용 요약 */}
          <div className="card" style={{ marginBottom: 20 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <h3 style={{ fontSize: 15, fontWeight: 600 }}>작성 내용 미리보기</h3>
              <button className="btn btn-secondary btn-sm" onClick={() => setShowForm(true)}>수정</button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: '4px 20px' }}>
              {selectedType.fields.filter(f => !['info', 'checkbox', 'personnel_table', 'expense_table', 'traveler_table', 'supply_table', 'richtext'].includes(f.type)).slice(0, 8).map(field => (
                <div key={field.key} style={{ display: 'flex', gap: 8, fontSize: 13, padding: '6px 0', borderBottom: '1px solid #f9fafb' }}>
                  <span style={{ color: '#9ca3af', minWidth: 90, flexShrink: 0 }}>{field.label}</span>
                  <span style={{ color: '#374151', wordBreak: 'break-all' }}>{formData[field.key] || '-'}</span>
                </div>
              ))}
            </div>
            {attachedFiles.length > 0 && (
              <div style={{ marginTop: 10, paddingTop: 10, borderTop: '1px solid #f3f4f6' }}>
                <span style={{ fontSize: 12, color: '#9ca3af' }}>첨부파일 {attachedFiles.length}개: </span>
                <span style={{ fontSize: 12, color: '#374151' }}>{attachedFiles.map(f => f.name).join(', ')}</span>
              </div>
            )}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
            <div className="card">
              <h3 style={{ fontSize: 15, fontWeight: 600, marginBottom: 6 }}>결재선 설정 *</h3>
              <p style={{ fontSize: 12, color: '#9ca3af', marginBottom: 14 }}>클릭하여 순서대로 결재자를 추가하세요</p>
              {loadingUsers
                ? <p style={{ fontSize: 13, color: '#9ca3af', textAlign: 'center', padding: '20px 0' }}>직원 목록 불러오는 중...</p>
                : allUsers.map(ap => {
                  const selected = isSelected(ap.id);
                  const order = getOrder(ap.id);
                  return (
                    <div key={ap.id} onClick={() => toggleApprover(ap)}
                      style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 8,
                        cursor: 'pointer', marginBottom: 6,
                        background: selected ? '#f0f0ff' : '#f9fafb',
                        border: `1.5px solid ${selected ? '#4f46e5' : 'transparent'}` }}>
                      <div className="avatar" style={{ width: 32, height: 32, fontSize: 12, flexShrink: 0, background: selected ? '#4f46e5' : '#d1d5db', color: '#fff' }}>
                        {selected ? order : ap.name[0]}
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 13, fontWeight: 500 }}>{ap.name}</div>
                        <div style={{ fontSize: 11, color: '#9ca3af' }}>{ap.dept} · {ap.position}</div>
                      </div>
                      {selected && <span style={{ fontSize: 11, color: '#4f46e5', fontWeight: 600 }}>{order}순위</span>}
                    </div>
                  );
                })
              }
            </div>
            <div>
              {approvers.length > 0 && (
                <div className="card" style={{ marginBottom: 16 }}>
                  <h3 style={{ fontSize: 14, fontWeight: 600, marginBottom: 12 }}>결재 흐름</h3>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                      <div className="avatar" style={{ width: 36, height: 36, fontSize: 12, background: '#6b7280' }}>{user.name[0]}</div>
                      <span style={{ fontSize: 11, color: '#6b7280' }}>기안</span>
                    </div>
                    {approvers.map((ap, i) => (
                      <React.Fragment key={ap.id}>
                        <span style={{ color: '#d1d5db', fontSize: 20 }}>›</span>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                          <div className="avatar" style={{ width: 36, height: 36, fontSize: 12, background: '#4f46e5' }}>{ap.name[0]}</div>
                          <span style={{ fontSize: 11, color: '#4f46e5', fontWeight: 600 }}>{i + 1}차</span>
                        </div>
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              )}
              <div className="card" style={{ marginBottom: 16 }}>
                <h3 style={{ fontSize: 14, fontWeight: 600, marginBottom: 10 }}>기안자</h3>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <div className="avatar" style={{ width: 36, height: 36, fontSize: 13 }}>{user.name[0]}</div>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 500 }}>{user.name}</div>
                    <div style={{ fontSize: 12, color: '#9ca3af' }}>{user.dept} · {user.position}</div>
                  </div>
                </div>
              </div>
              <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', padding: 13, fontSize: 15 }} onClick={handleSubmit}>
                ✅ 결재 상신
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
